import { useParams } from 'react-router-dom';

import { CampaignDetailModel, useStaffGetCampaign } from '@urbanx/agx.campaigns.client';

export const createCampaignDetailsQueryKey = (campaignId: string | undefined) => [
  'staffGetCampaign',
  campaignId,
];

const useSelectedCampaign = (): {
  campaign?: CampaignDetailModel;
  isLoading: boolean;
  isFetched: boolean;
} => {
  const { campaignId } = useParams();

  const { data: campaign, isPending } = useStaffGetCampaign(campaignId || '', !!campaignId);

  return {
    campaign,
    isLoading: !!campaignId && isPending,
    isFetched: !!campaignId && !isPending,
  };
};

export default useSelectedCampaign;
